import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  phoneFocus: false,
};

export const inputFocusSlice = createSlice({
  name: 'inputFocus',
  initialState,
  reducers: {
    phoneFocus: (state, action: PayloadAction<boolean>) => {
      state.phoneFocus = action.payload;
    },
  },
});

export const { phoneFocus } = inputFocusSlice.actions;
export default inputFocusSlice.reducer;
